'use server';

import { SessionService } from '@/contexts/authentication';
import { objectKeyFromStored } from '@/contexts/media/storage/StorageProvider';

/**
 * Generic download URL generator — detects storage type from the stored ref
 * (KEY or legacy URL) and uses the correct storage class to presign.
 */
export async function getDownloadUrl(fileRef: string, filename?: string): Promise<string | null> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return null;

  // Ownership: only sign objects that belong to the caller's family (IDOR guard).
  const { isBlobOwnedByFamily } = await import('./blobOwnership');
  if (!(await isBlobOwnedByFamily(fileRef, familyId))) return null;

  // Detect storage type from the resolved object key.
  const key = objectKeyFromStored(fileRef);
  const isAudio = key.startsWith('story-audio/') || key.includes('/audio/');

  if (isAudio) {
    const { AudioStorage } = await import('@/contexts/media/storage/AudioStorage');
    const audioStorage = new AudioStorage();
    return audioStorage.getDownloadUrl(key, filename);
  }

  // Default: book images / other media
  const { BookImageStorage } = await import('@/contexts/media/storage/BookImageStorage');
  return BookImageStorage.getDownloadUrl(key, filename);
}
